import { BottomSheet } from 'app/design/primitives/bottom-sheet';
import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';

import type { NewScreenParams } from './index';
import type { PublishPromptType } from 'app/atoms/ui';

import { Platform, Pressable, View, useWindowDimensions } from 'react-native';
import { useNewListingPromptContent } from './use-new-listing-prompt-content';
import { createTheme as createDSTheme } from 'app/shopify';
import { IconChevronLeft } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { ScrollView } from 'react-native-gesture-handler';
const theme = createDSTheme();
const CONTENT_CONTAINER_STYLE = {
  gap: theme.spacing['spacing.general.x2'],
  paddingBottom: Platform.OS === 'android' ? theme.spacing['spacing.general.x5'] : 0,
  paddingTop: theme.spacing['spacing.general.x4'],
};

interface NewListingPromptProps {
  state: [boolean | PublishPromptType, React.Dispatch<React.SetStateAction<boolean | PublishPromptType>>];
  newScreenParams?: NewScreenParams;
  onHoverIn?: () => void;
  onHoverOut?: () => void;
}

const NewListingPrompt = function NewListingPrompt({ state, newScreenParams }: NewListingPromptProps) {
  const [isNewListingPromptVisible, setIsNewListingPromptVisible] = state;
  const { form, centralizedCreation } = useNewListingPromptContent({ state, newScreenParams });
  const { height: windowHeight } = useWindowDimensions();

  if (centralizedCreation) return null;

  return (
    <BottomSheet
      containerStyle={{ paddingHorizontal: theme.spacing['spacing.general.x4'] }}
      onClose={() => setIsNewListingPromptVisible(false)}
      open={Boolean(isNewListingPromptVisible)}
      showIndicator={false}
    >
      {form ? (
        <>
          <Row alignItems="center">
            {form.onBack ? (
              <Pressable onPress={form.onBack}>
                <IconChevronLeft strokeWidth={ICON_STROKE_WIDTH} />
              </Pressable>
            ) : null}
            <Text fontWeight="700" style={{ flexGrow: 1 }} textAlign="center" variant="headerXSmall">
              {form.title}
            </Text>
            {form.onBack ? <View style={{ width: 30 }} /> : null}
          </Row>
          <Column style={{ maxHeight: windowHeight * 0.65 }}>
            <ScrollView
              contentContainerStyle={CONTENT_CONTAINER_STYLE}
              nestedScrollEnabled
              showsVerticalScrollIndicator
            >
              {form.buttons}
            </ScrollView>
          </Column>
        </>
      ) : null}
    </BottomSheet>
  );
};

export { NewListingPrompt };
